import { useState, useEffect, useRef } from "react";
import { createMarkup, isStartsWith, useWindowDimensions } from "@cti-workspace/helpers";
import { Button as Btn, Dialog, Icon, Typography as Text } from "@cti-workspace/ui";
import { getObjectValue } from "@cti-workspace/helpers";
import { dateFomat } from "../utils/dateFormat";
import { AccentTitle, Description, Title, SubTitle1, SubTitle2, Link, Content, Resources } from "./Typography";
import { SectionClaimsTable } from "../components";
import { PrintButton } from "./Button";
import { hexToRGB } from "./util";
// <Text onClick={() => window.open(value, "_blank")} type="body1" color={color || "textValue"}></Text>;
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { AdditionalContentResourcesGrid } from "./Layout";
import { isHTML } from "../helpers";
import sanitizeHTML from "sanitize-html"

function LabelValueRow({ label = "", value = "", theme, type = "", style = {} }) {
	return (
		<div style={{ padding: 0 }}>
			<SubTitle1 theme={theme} textTransform={"uppercase"}>
				{label}
			</SubTitle1>
			{type === "link" ? (
				<Link theme={theme} href={value} target="_blank" rel="noopener noreferrer">
					{value}
				</Link>
			) : (
				<SubTitle2 theme={theme}>{value}</SubTitle2>
			)}
		</div>
	);
}

// Function that takes a string and capitalizes the first letter 
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function camelCaseToSpace(string) {
  // Add a space after the last capital letter in a sequence of capital letters, unless it's at the end of the string
  return string.replace(/([a-z])([A-Z])|([A-Z]+)(?=[A-Z][a-z])/g, (match, lowerToUpper, singleUpper, multipleUpper) => {
    if (lowerToUpper) {
      return `${lowerToUpper} ${singleUpper}`;
    }
    if (multipleUpper) {
      return `${multipleUpper} `;
    }
    return match;
  });
}


function removeEmptyBrTagSpaceTag(txt = "") {
	const txtMain = txt.replace(/>\s+|\s+</g, (m) => m.trim()).replace(/<[^/>][^>]*><\/[^>]+>/g, "");
	return txtMain
		.split("<p><br></p>")
		.filter((item) => item)
		.join("<p><br></p>");
}

function CertContentRight({ theme = {}, parsedDoc = {}, additionalDataMain = {}, credExpired = false }) {
	const locale = additionalDataMain?.settings?.verifierConfiguration?.locale;
	const hideContent = additionalDataMain?.settings?.verifierConfiguration?.hideContent;
	const hideSections = additionalDataMain?.settings?.verifierConfiguration?.hideSections;
	const hideResources = additionalDataMain?.settings?.verifierConfiguration?.hideResources;
	const { name, credentialSubject, description: descriptionMain, issuers, issuer, recipient, issuanceDate, expirationDate } = parsedDoc;
	const [showExpand, setShowExpand] = useState(false);
	const [isExpand, setIsExpand] = useState(false);
	const [containerHeight, setContainerHeight] = useState(0);
	const [zoomImage, setZoomImage] = useState(0);

	const nameContainerRef = useRef(null);
	const descriptionContainerRef = useRef(null);
	const issuerContainerRef = useRef(null);

	// const { height } = useWindowDimensions();
	const unescape = window.unescape || window.decodeURI;

	const description = removeEmptyBrTagSpaceTag(descriptionMain);

	// console.log(zoomImage);

	useEffect(() => {
		if (descriptionContainerRef.current && description) {
			if (isExpand) {
				return;
			}
			const nameContainerHeight = (nameContainerRef.current.offsetHeight || 0) + (issuerContainerRef.current.offsetHeight || 0);
			if (descriptionContainerRef.current.offsetHeight > nameContainerHeight + 150) {
				setContainerHeight(nameContainerHeight);
				descriptionContainerRef.current.style.height = `calc(100vh - ${nameContainerHeight + 150}px)`;
				setShowExpand(true);
			}
		}
	}, [descriptionContainerRef.current]);

	const resourceType = (val) => {
		try {
			const ext = val.split(".").pop();
			if (["jpg", "png", "jpeg"].includes(ext.toLowerCase())) {
				return "image";
			} else if (ext.toLowerCase() === "pdf") {
				return "pdf";
			} else {
				return "link-simple-horizontal";
			}
		} catch (e) {
			return "link-simple-horizontal";
		}
	};

	const styleDataResourceBreak = (data) => (/_|-/g.test(data) ? { wordBreak: "break-all" } : { wordBreak: "break-word" });

	return (
		<div style={{ width: "100%" }}>
			<div ref={nameContainerRef} style={{ ...(description ? { borderBottom: "1px dashed #E0E0E0" } : {}), paddingBottom: "0.9rem" }}>
				<Title theme={theme}>{name}</Title>
				<AccentTitle theme={theme}>{credentialSubject?.name}</AccentTitle>
			</div>

			<div ref={descriptionContainerRef} style={{ overflow: "hidden" }}>
				{description && <Description theme={theme} dangerouslySetInnerHTML={createMarkup(unescape(description))} />}
				{!hideContent && getObjectValue(parsedDoc, "credentialSubject.results", []).length > 0 && (
					<div style={{ display: "grid", gridTemplateRows: "auto", gridTemplateColumns: "auto", gap: "0.5rem", paddingBlock: "1.5rem", borderTop: "1px dashed #E0E0E0", marginTop: "0rem" }}>
						{getObjectValue(parsedDoc, "credentialSubject.results", []).map((item) => (
							<div key={item.name}>
                <Content theme={theme}>
                  {camelCaseToSpace(capitalizeFirstLetter(item.name)) + ": "}
									{/(data:image\/[^;]+;base64[^"]+)/i.test(item.value) ? (
										<img alt={item.name} src={item.value} style={{ maxHeight: "50px", display: "block", marginTop: "0.25rem" }} />
									) : isStartsWith(item.value, "http") ? (
										": " +
										(
											<a href={item.value} target="_blank" rel="noopener noreferrer">
												{item.value}
											</a>
										)
									) : isHTML(item.value) ?  <span style={{ maxHeight: "50px",marginLeft:"0.1rem" , marginTop: "0.25rem" }} dangerouslySetInnerHTML={createMarkup(sanitizeHTML(item.value))} /> : ` ${item.value}`}
								</Content>
							</div>
						))}
					</div>
				)}
				{!hideResources && getObjectValue(parsedDoc, "additionalData.resources", []).length > 0 && (
					<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", paddingBlock: "1rem", borderTop: "1px dashed #E0E0E0" }}>
						<style>
							{`
							.additional-content-pdf-thumbnail-resources {
								height: 150px;
								display: flex;
								cursor: pointer;
							}

							.additional-content-pdf-thumbnail-resources .react-pdf__Document {
								display: flex;
								flex-direction: column;
								align-items: center;
							}

							.additional-content-pdf-thumbnail-resources .react-pdf__Page {

							}

							.additional-content-pdf-thumbnail-resources .react-pdf__Page canvas {
								max-width: max-content;
								height: 150px !important;
							}

							.additional-content-pdf-thumbnail-resources .react-pdf__message {
								padding: 20px;
								color: white;
							}
							`}
						</style>
						<SubTitle1 theme={theme}>RESOURCES</SubTitle1>
						<AdditionalContentResourcesGrid>
							{getObjectValue(parsedDoc, "additionalData.resources", []).map((resource) => (
								<div key={resource.id}>
									{resourceType(resource.url) === "pdf" ? (
										<ResourcePDFView data={resource} theme={theme} />
									) : (
										<div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
											<div>
												<Icon name={resourceType(resource.url)} />
											</div>
											{resourceType(resource.url) !== "image" ? (
												<Resources theme={theme} style={styleDataResourceBreak(resource.id)}>
													<Link theme={theme} href={resource.url} target="_blank" rel="noopener noreferrer" style={styleDataResourceBreak(resource.id)}>
														{resource.id}
													</Link>
												</Resources>
											) : (
												<Resources theme={theme} style={styleDataResourceBreak(resource.id)}>
													{resource.id}
												</Resources>
											)}
										</div>
									)}
									{resourceType(resource.url) === "image" && (
										<>
											<img
												alt={resource.id}
												src={resource.url}
												onClick={() => setZoomImage(resource.id)}
												style={{
													maxHeight: "100px",
													// objectFit: "cover",
													marginTop: "0.25rem",
													maxWidth: "100%",
												}}
											/>
											<Dialog key={resource.id} open={resource.id === zoomImage} disableBackdropClick={false} disableEscapeKeyDown={false} maxWidth="lg" borderRadius="8px" onClose={() => setZoomImage(0)} isDialogContainerActive={false}>
												<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
													<div style={{ display: "flex" }}>
														<img
															alt={resource.id}
															src={resource.url}
															style={{
																// maxHeight: "100px",
																objectFit: "cover",
																marginTop: "0.25rem",
																width: "auto",
																maxHeight: "80vh",
																height: "auto",
															}}
														/>
														<span style={{ marginLeft: "0.5rem" }}>
															<Btn
																buttonType="icon"
																color={"white"}
																icon="cancel-circle"
																iconStyle={{ weight: "fill", color: "#C0C0C0" }}
																noBorder={true}
																borderRadius={"50%"}
																buttonStyle={{ padding: 0, backgroundColor: "transparent" }}
																iconSize="2rem"
																onClick={(e) => {
																	e?.stopPropagation();
																	setZoomImage(0);
																}}
															/>
														</span>
													</div>
												</div>
											</Dialog>
										</>
									)}
								</div>
							))}
						</AdditionalContentResourcesGrid>
					</div>
				)}
				{!hideSections && getObjectValue(parsedDoc, "additionalData.sections", []).length > 0 && (
					<div style={{ display: "flex", flexDirection: "column", gap: "0.3rem", paddingTop: "1.2rem", paddingBottom: "1.5rem", borderTop: "1px dashed #E0E0E0" }}>
						<SubTitle1 theme={theme}>SECTIONS</SubTitle1>
						{getObjectValue(parsedDoc, "additionalData.sections", []).map((section) => (
							<div key={section.displayName}>
								<Resources theme={theme}>{section.displayName}</Resources>
								<Description theme={theme}> {section.description}</Description>
								<div style={{ marginTop: "0.3rem" }} />
								<SectionClaimsTable rows={section.claims} theme={theme} />
							</div>
						))}
					</div>
				)}
			</div>

			{showExpand && (
				<>
					<div style={{ display: "flex", justifyContent: "center", paddingBlock: "0.5rem", paddingInline: "30%" }}>
						<PrintButton
							theme={theme}
							onClick={() =>
								setIsExpand((prevState) => {
									if (prevState) {
										descriptionContainerRef.current.style.height = `calc(100vh - ${containerHeight + 150}px)`;
									} else {
										descriptionContainerRef.current.style.height = "auto";
									}
									return !prevState;
								})
							}>
							<Icon name={"arrowVertical"} size={23} weight={"fill"} color={hexToRGB(theme.primaryColor, theme.primaryColorOpacity)} />
							{isExpand ? "Collapse" : "Expand"}
						</PrintButton>
						{/* <Btn
							leftIcon="arrowVertical"
							color="primary"
							invert
							borderRadius="8px"
							buttonStyle={{ marginBottom: "0.5rem", border: "1px solid #E0E0E0", fontSize: "0.875rem", padding: "0.8rem 1.5rem" }}
							onClick={
							}>

						</Btn> */}
					</div>
					<div style={{ borderBottom: "1px dashed #E0E0E0" }} />
				</>
			)}
			<div style={{ display: "flex", flexDirection: "column", gap: "1rem", paddingTop: "1.4rem", borderTop: "1px dashed #E0E0E0" }} ref={issuerContainerRef}>
				<LabelValueRow theme={theme} label="Issued By" value={getObjectValue(issuer, "name")} />
				<div style={{ display: "flex", gap: "1.9rem" }}>
					<LabelValueRow theme={theme} label="Issued On" value={dateFomat({ date: issuanceDate, locale })} />
					{expirationDate && (
						<LabelValueRow
							theme={{
								...theme,
								...(credExpired
									? {
											fontColor2: "#FC7377",
											fontColor2Opacity: 1,
									  }
									: {}),
							}}
							label="Expires On"
							value={`${dateFomat({ date: expirationDate, locale })}${credExpired === true ? " (Expired)" : ""}`}
						/>
					)}
				</div>
				<LabelValueRow theme={theme} label="Verified Domain" value={getObjectValue(issuer, "url")} type="link" />
				<LabelValueRow theme={theme} label="Document Id" value={getObjectValue(parsedDoc, "id")} />
			</div>
		</div>
	);
}

function ResourcePDFView({ data = {}, theme = {} }) {
	const styleData = /_|-/g.test(data.id) ? { wordBreak: "break-all" } : { wordBreak: "break-word" };
	return (
		<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
			<div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
				<Icon name="pdf" />
				<Resources theme={theme} style={styleData}>
					<Link theme={theme} href={data.url} target="_blank" rel="noopener noreferrer" style={styleData}>
						{data.id}
					</Link>
				</Resources>
			</div>

			<div className="additional-content-pdf-thumbnail-resources">
				{/* <Link theme={theme} href={data.url} target="_blank" rel="noopener noreferrer"> */}
				{/* <Document file={`${data.url}?timestamp=${new Date().getTime()}`}>
						<Page pageNumber={1} />
					</Document> */}
				<DocumentView data={data} />
				{/* </Link> */}
			</div>
		</div>
	);
}

function DocumentView({ data = {} }) {
	return (
		<Document file={`${data.url}`} onItemClick={(e) => e.preventDefault()}>
			<Page
				pageNumber={1}
				onClick={(e) => {
					e.preventDefault();
					if (!data.url) return;
					const a = document.createElement("a");
					a.href = data.url;
					a.click();
				}}
			/>
		</Document>
	);
}

export default CertContentRight;
